import React, { Component } from "react"

import {
    Container,
    Card,
    CardBody,
    CardText,
    Button,
    Row,
    Col,
    Table
} from "reactstrap"
import MetaTags from 'react-meta-tags'
import logodark from "assets/images/logo-dark.png"

import pdficon from "assets/images/pdficon.jpg"

import PropsTypes from "prop-types"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"


class BirthChartPaymentInvoice extends Component {
    constructor(props) {
        super(props)
        this.state = {
            invoiceDetails: {},
            actionResult: {},
            actionResultChanged: false,
            birthDetail: {
                invoiceAmount: 1000,
                invoiceCurrency: 'INR'
            }
        }

        this.makePayment = this.makePayment.bind(this)
    }

    makePayment() {
        console.log("payment status makePaymentSaga")
        localStorage.setItem("PaymentState", "Inititated");
        const birthDetail = this.state.birthDetail
        const paymentLink = birthDetail.paymentLink
        console.log("paymentLink: ", paymentLink)
        window.location.href = paymentLink
    }

    componentDidMount() {
        const birthDetail = this.props.location.state.birthDetail
        this.setState({ birthDetail })
    }

    render() {
        const { invoiceDetails, birthDetail } = this.state
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Payment Invoice | Kattam</title>
                    </MetaTags>
                    <Container fluid className="p-0">
                        {/* Render Breadcrumbs */}
                        <Breadcrumbs title="" breadcrumbItem="Checkout" />
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody>
                                        {/* <div className="invoice-title">
                                            <div className="mb-0">
                                                <img src={logodark} alt="logo" height="40" />
                                            </div>
                                        </div>
                                        <hr /> */}
                                        <div className="py-2 mt-0">
                                            <h3 className="font-size-15 font-weight-bold">
                                                Order summary
                                            </h3>
                                        </div>
                                        <div className="table-responsive" >
                                            <Table className="table-nowrap" style={{ backgroundColor: '#f7eacb' }}>
                                                <thead className="thead-light" style={{ backgroundColor: '#dfb53d' }}>
                                                    <tr>
                                                        <th style={{ width: "100px" }}>Product</th>
                                                        <th>Description</th>
                                                        <th className="text-end">Price</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                
                                                    <tr style={{ borderBottom: '1px solid #dfb53d' }} className="py-2">
                                                        <td>
                                                        <br></br>
                                                            <img src={pdficon} alt="pdficon" height="60" />
                                                        </td>
                                                        <td style={{ verticalAlign: 'middle' }}>Kattam Intelligence AI health predictive report</td>
                                                        <td className="text-end" style={{ verticalAlign: 'middle' }}>
                                                            {}{birthDetail.invoiceAmount}{" "}{birthDetail.invoiceCurrency}
                                                        </td>
                                                    </tr>

                                                    <tr style={{ borderBottom: '1px solid #dfb53d' }}>
                                                        <td colSpan="2" className="border-0 text-end">
                                                            <strong>Total</strong>
                                                        </td>
                                                        <td className="border-0 text-end">
                                                            <h4 className="m-0">
                                                                {}{birthDetail.invoiceAmount}{" "}{birthDetail.invoiceCurrency}
                                                            </h4>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                        <div className="d-print-none">
                                            <div className="float-end">
                                                <button
                                                    className="btn btn-primary btn-md btn-block waves-effect waves-light me-1"
                                                    type="submit"
                                                    onClick={this.makePayment}
                                                >
                                                    Pay and Download Report
                                                </button>
                                            </div>
                                        </div>
                                        <CardText className="mt-5">
                                            <small className="text-muted float-end">
                                                Payment will take you to another website, please don't refresh.
                                                After successful payment you will be redirected to kattam. Your report will be mailed to your registered email address.
                                            </small>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

BirthChartPaymentInvoice.propsTypes = {
    birthDetail: PropsTypes.object,
    loading: PropsTypes.bool,
}

export default BirthChartPaymentInvoice

